// FriendsDemo.jsx
import styled from "styled-components";
import { FullWidthSection as BaseFullWidthSection, FeatureRow, FeatureRowText, FeatureRowVisual } from "./DemoFeatureRow";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserFriends } from "@fortawesome/free-solid-svg-icons";
import { FriendCardRow } from "../../friends/FriendCard";

// ---- Mise en page englobante ----
// Étend le bloc partagé pour ajouter le style spécifique à cette démo
// (état "actif" simulé sur les cartes ami), sans dupliquer le reste.
const FullWidthSection = styled(BaseFullWidthSection)`
  .demo-simulated-active {
    background: #eef8f1 !important;
    border-color: #b9d8c0 !important;
    color: #22663f !important;
    box-shadow: 0 0 0 3px rgba(76, 175, 80, 0.12);
  }
`;

// Repris tel quel de FriendsList.jsx
const FriendsGrid = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid #e1e8ed;
  border-radius: 12px;
  overflow: hidden;
  background: #ffffff;

  @media (max-width: 1024px) {
    border-radius: 10px;
  }
`;

// ---- Données mock ----
const MOCK_CURRENT_USER = { id: 1, username: 'moi' };

const MOCK_FRIENDS = [
  {
    id: 'demo-f1',
    createdAt: '2026-03-14T10:00:00',
    sender: { id: 1, username: 'moi' },
    receiver: {
      id: 2,
      username: 'claire.dupont',
      firstname: 'Claire',
      lastname: 'Dupont',
      avatar: null,
    },
  },
  {
    id: 'demo-f2',
    createdAt: '2026-05-02T10:00:00',
    sender: {
      id: 3,
      username: 'thomas.lefevre',
      firstname: 'Thomas',
      lastname: 'Lefèvre',
      avatar: null,
    },
    receiver: { id: 1, username: 'moi' },
  },
  {
    id: 'demo-f3',
    createdAt: '2026-07-20T10:00:00',
    sender: { id: 1, username: 'moi' },
    receiver: {
      id: 4,
      username: 'sofia.martins',
      firstname: 'Sofia',
      lastname: 'Martins',
      avatar: null,
    },
  },
];

// ---- Composant ----
const FriendsDemo = () => {
  const [firstFriend, ...otherFriends] = MOCK_FRIENDS;

  return (
    <FullWidthSection>

      {/* Bloc 1 — Journal partagé (ami mis en avant) */}
      <FeatureRow $reverse>
        <FeatureRowText $reverse>
          <h3><FontAwesomeIcon icon={faUserFriends} /> Mes amis</h3>
          <p>
            Ajoutez vos amis pour partager vos journaux et vous encourager
            mutuellement dans le suivi de votre nutrition, sommeil et poids.
          </p>
        </FeatureRowText>
        <FeatureRowVisual className="demo-preview-visual" $reverse>
          <FriendsGrid className="landing-friends-grid">
            <FriendCardRow
              friend={firstFriend}
              currentUser={MOCK_CURRENT_USER}
              mode="demo"
              className="landing-friend-entry"
            />
          </FriendsGrid>
        </FeatureRowVisual>
      </FeatureRow>

      {/* Bloc 2 — Le reste de la liste */}
      <FeatureRow>
        <FeatureRowText>
          <h3><FontAwesomeIcon icon={faUserFriends} /> Retrouvez toute votre liste</h3>
          <p>
            Tous vos amis sont regroupés au même endroit, avec la date de
            début de votre amitié, pour garder une trace de votre communauté
            au fil du temps.
          </p>
        </FeatureRowText>
        <FeatureRowVisual className="demo-preview-visual">
          <FriendsGrid className="landing-friends-grid">
            {otherFriends.map((friend) => (
              <FriendCardRow
                key={friend.id}
                friend={friend}
                currentUser={MOCK_CURRENT_USER}
                mode="demo"
                className="landing-friend-entry"
              />
            ))}
          </FriendsGrid>
        </FeatureRowVisual>
      </FeatureRow>

    </FullWidthSection>
  );
};

export default FriendsDemo;
